<template>
	<div>
		<botao-voltar label-voltar="voltar para listagem" :nome-rota-anterior="rotaListagem"></botao-voltar>
		<az-container>
			<painel-com-tabs
				v-if="situacaoAta"
				:abas="Object.values(abas)"
				:key="Object.keys(abas).join('-')"
				dark
			></painel-com-tabs>
		</az-container>
	</div>
</template>
<script>
import PainelComTabs from '@/views/components/PainelComTabs.vue'
import { actionTypes, getterTypes, routesNames } from '@/core/constants'
import { mapGetters } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'

export default {
	name: 'acessar-ata-view',
	components: { PainelComTabs },
	mixins: [validacaoAta],
	data() {
		return {
			rotaListagem: routesNames.ATA.ATA_VIEW,
		}
	},
	computed: {
		...mapGetters({
			situacaoAta: getterTypes.ATA.GET_SITUACAO_DA_ATA,
			abas: getterTypes.ATA.ABAS_INTERNAS_DA_ATA,
		}),
	},
	async created() {
		await this.carregarInformacoesDaAta()
	},
	methods: {
		async carregarInformacoesDaAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.$route.params.id)
		},
	},
}
</script>
